"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractUTMParameters = void 0;
var capitalizedFirst = function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
};
/**
 * Extracts UTM parameters from the URL
 * @param url
 * @returns
 */
var extractUTMParameters = function (url) {
    var result = {};
    try {
        var urlObj = new URL(url);
        var UTM_PREFIX_1 = 'utm_';
        urlObj.searchParams.forEach(function (value, sParam) {
            if (sParam.startsWith(UTM_PREFIX_1)) {
                var utmParam = sParam.substring(UTM_PREFIX_1.length);
                // utm_campaign represents the name
                if (utmParam === 'campaign') {
                    utmParam = 'name';
                }
                result["utm".concat(capitalizedFirst(utmParam))] = value;
            }
        });
    }
    catch (_) {
        // Do nothing
    }
    return result;
};
exports.extractUTMParameters = extractUTMParameters;
